import { Injectable } from "@angular/core";
import firebase from 'firebase/app';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";
import { map } from 'rxjs/operators';
import { rejects } from "assert";
import { leftJoin} from "../database/leftjoin";
import * as moment from 'moment';
import { Headers, RequestOptions, Http } from "@angular/http";
import { AuthProvider } from "../auth/auth";
import * as _ from "lodash";
import { rx } from '../../models'
import { ENV } from '@app/env'

export interface Other {
  userId: string;
  createdAt: Date;
  image: string;
  content: string;
  [key: string]: any;
}

export interface clinic {
  id?: string;
  program_id: string;
  clinic_name: string;
  createdAt: any;
  updatedAt: any;
}

export interface medication {
  id?: string;
  din: string;
  name: string;
  type: string;
  createdAt: any;
  updatedAt: any;
  logo?: string;
  category?: string;
  sort?: number;
}

export interface doctor {
  id?: string;
  first_name: string;
  last_name: string;
  license: string;
  createdAt: any;
  updatedAt: any;
}

export interface patient {
  id?: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  address: string;
  city: string;
  postal_code: string;
  province: string;
  shipping_address: string;
  shipping_city: string;
  shipping_postal_code: string;
  address2: string;
  shipping_address2: string;
  shipping_province: string;
  gender: string;
  dob: string;
  createdAt: any;
  updatedAt: any;
}

@Injectable()
export class DatabaseProvider {
  constructor(private afs: AngularFirestore, public http: Http, public auth: AuthProvider) {}

    // Get Clinics
    getPrograms() {
      return this.afs.collection<any>("programs", ref =>
        ref
          .orderBy("program_name", "asc")
      );
    }

  /*********CLINICS **********************************/
  // Get Clinics
  getClinics() {
    return this.afs.collection<clinic>("clinics", ref =>
      ref
        .orderBy("name", "asc")
    );
  }

  // Get Single Clinic
  getClinic(id) {
    return this.afs.collection<clinic>(`clinics`).doc(id);
  }

  // Create Clinic
  createClinic(data: clinic, user) {
    const id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    const doc = { createdAt, createdBy, updatedAt, updatedBy, ...data };
    return this.afs.collection<clinic>("clinics").add(doc);
  }


  getUserStatus(userId: string) {
    return this.afs.collection("users", ref =>
      ref
        .where("userId", "==", userId)
        .limit(1)
    );
  }

  getClinicsByUser(userId: string) {
    return this.afs.collection<clinic>("clinics", ref =>
      ref
        .orderBy("createdAt", "desc")
        .where("userId", "==", userId)
        .limit(10)
    );
  }
  getIndicationByProgram(program_id, indication) {
    return this.afs.collection<any>(`program/${program_id}/indications/`).doc(indication);
  } 

  getDoctors() {
    return this.afs.collection<doctor>(`doctors`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getDoctorsByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/doctors`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getDocumentsByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/docsfiles`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  getNewDocumentsByProgramIncomplete(program_id) {
    return this.afs.collection<any>(`program/${program_id}/docsfiles`, ref =>
      ref
        .where("type", "==", "Incoming Fax")
        .where("completed", "==", false)
        .orderBy("createdAt", "desc")
    );
  }

  getDocumentsByProgramIncomplete(program_id) {
    return this.afs.collection<any>(`program/${program_id}/docsfiles`, ref =>
      ref
        .orderBy("createdAt", "desc")
    );
  }

  getDocumentsByProgramComplete(program_id) {
    return this.afs.collection<doctor>(`program/${program_id}/docsfiles`, ref =>
      ref
        .orderBy("createdAt", "desc")
    );
  }

  updateDoctor(program_id, doctor_id, data: doctor) {
    const updatedAt = this.timestamp;
    const doc = { updatedAt, ...data };

    return this.afs.doc(`program/${program_id}/doctors/${doctor_id}`).update(doc);
  }

  addDoctor(program_id, data) {
    const createdAt = this.timestamp;
    const updatedAt = createdAt;
    const doctorId = this.afs.createId();
    const doc = { createdAt, updatedAt, ...data };

    return this.afs.doc(`program/${program_id}/doctors/${doctorId}`).set(doc);
  }

  

  deleteDoctor(program_id, doctor_id) {
    var batch = this.afs.firestore.batch();
    const doctorRef = this.afs.doc(`clinics/${program_id}/doctors/${doctor_id}`).ref;
    batch.delete(doctorRef);
    return batch.commit();
  }

  getClinicsByProgram(program_id) {
    return this.afs.collection<doctor>(`program/${program_id}/clinics`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  updateClinic(program_id, clinic_id, data: clinic) {
    const updatedAt = this.timestamp;
    const doc = { updatedAt, ...data };

    return this.afs.doc(`program/${program_id}/clinics/${clinic_id}`).update(doc);
  }

  addClinic(program_id, data) {
    const createdAt = this.timestamp;
    const updatedAt = createdAt;
    const clinicId = this.afs.createId();
    const doc = { createdAt, updatedAt, ...data };

    return this.afs.doc(`program/${program_id}/clinics/${clinicId}`).set(doc);
  }

  deleteClinic(program_id, clinic_id) {
    var batch = this.afs.firestore.batch();
    const clinicRef = this.afs.doc(`clinics/${program_id}/clinics/${clinic_id}`).ref;
    batch.delete(clinicRef);
    return batch.commit();
  }

  getStudyForMedicationsByClinic(program_id, documentreference) {
    return this.afs.doc(documentreference);
  } 


  getStudiesByClinic(program_id) {
    return this.afs.collection<doctor>(`clinics/${program_id}/studyresults`);
  } 

  getStudyEnrolments() {
    return this.afs.collection<doctor>(`studyresults`);
  } 

  saveOrder(program_id: string, clinic_name: string, order) {
    order['status'] = "Queued";
    order['program_id'] = program_id;
    order['clinic_name'] = clinic_name;
    order['createdAt'] = this.timestamp;
    const id = this.afs.createId();

    var batch = this.afs.firestore.batch();
    const preRef = this.afs.doc(`orders/${id}`).ref;
    batch.set(preRef , order);

    const clinicRef = this.afs.doc(`clinics/${program_id}/orders/${id}`).ref;
    batch.set(clinicRef , order);

    // If RX Order
    if (order.rx) {
      if(order.rx.length > 0) { 
        _.forEach(order.rx, (order_batch) => {
          let signature = order_batch['signature'];
          _.forEach(order_batch['rx'], (rx, idx) => {
            const createdAt = this.timestamp;
            const updatedAt = createdAt;
            const rx_id = this.afs.createId();
            rx['doctor']['signature'] = signature;
            const new_rx = { createdAt, updatedAt, rx_id, ...rx };

            const patientRxRef = this.afs.doc(`clinics/${program_id}/patients/${rx['patient']['id']}/prescriptions/${rx_id}`).ref;
            batch.set(patientRxRef, new_rx);

            const patientRef = this.afs.doc(`clinics/${program_id}/patients/${rx['patient']['id']}`).ref;
            batch.update(patientRef, {'last_rx': new_rx});
          });
        });
      }
    }
    return batch.commit();
  }

  getNCMs() {
    return this.afs.collection<any>(`users/`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getAdminSettings(program_id) {
    return this.afs.collection<any>(`program/${program_id}/admin`, ref =>
      ref.orderBy("sort", "asc")
    );
  }

  getTherapyByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/therapy`, ref =>
      ref.orderBy("name", "desc")
    );
  }

  getInsurersByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/insurers`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getPharmaciesByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/pharmacies`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getEnrolmentsByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/enrolments`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  getEnrolmentsByProgramUnprocessed(program_id) {
    return this.afs.collection<any>(`program/${program_id}/enrolments`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }


  getIndicationsByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/indications`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getPatientsByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/patients`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getPatientsByProgramDateRange(program_id, query_field, start_date, end_date) {
    let startDate = moment(start_date).toDate();
    let endDate = moment(end_date).toDate();
    console.log('Start Date: ', startDate);
    console.log('End Date: ', endDate);
    console.log('Query: ', query_field);
    return this.afs.collection<any>(`program/${program_id}/patients`, ref =>
      ref
        .where(query_field, '>=', startDate)
        .where(query_field, '<=', endDate)
        .orderBy(query_field, 'desc')
      );
  }

  getPatientsByProgramMTD(program_id, year, month) {
    const date = year + '-' + month + '-01'
    console.log('MTD: ', date)
    const now = new Date(date);
    const lastMidnight = now.setHours(0,0,0,0) - 8600;    
    const beginningDateObject = new Date(lastMidnight);
    return this.afs.collection<any>(`program/${program_id}/patients`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('createdAt', '>', beginningDateObject);
      return query.orderBy("createdAt", "desc");
    })
  }

  getPatientsByProgramYTD(program_id, year) {
    const date = year + '-01-01';
    console.log('YTD: ', date)
    const now = new Date(date);
    const lastMidnight = now.setHours(0,0,0,0) - 8600;    
    const beginningDateObject = new Date(lastMidnight);
    return this.afs.collection<any>(`program/${program_id}/patients`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('createdAt', '>', beginningDateObject);
      return query.orderBy("createdAt", "desc");
    })
  }

  getTasksByProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/tasks`, ref =>
      ref.orderBy("priority", "desc")
    );
  }

  getStatusHistoryFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/status_history`, ref =>
      ref.orderBy("status_date", "desc")
    );
  }

  getChartFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/chart_history`, ref =>
      ref.orderBy("date", "desc")
    );
  }

  getDispensingFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/dispensing_history`, ref =>
      ref.orderBy("fill_date", "desc")
    );
  }

  getAEFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/ae_history`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  getTasksFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/task_history`, ref =>
      ref.orderBy("task_priority", "asc")
    );
  }

  getOrdersFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/order_history`, ref =>
      ref.orderBy("rx_date", "desc")
    );
  }

  getOrdersFromProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/orders`, ref =>
    ref.orderBy("rx_date", "desc")
  );
  }

  getDispensingFromProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/dispensing`, ref =>
    ref.orderBy("fill_date", "desc")
    );
  }

  getDispensingFromProgramwithPatient(program_id: string) {
    return this.afs.collection<any>(`program/${program_id}/dispensing`, ref =>
      ref.orderBy("fill_date", "desc")
    )
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = data.patient.id;
        return data;
      });
    })
    .pipe( 
      leftJoin(this.afs, 'id', `program/${program_id}/patients`, 1)
    )
}
  

  getAEFromProgram(program_id) {
    return this.afs.collection<any>(`program/${program_id}/adverseevents`, ref =>
    ref.orderBy("createdAt", "desc")
  );
  }

  getReimbursementsFromPatient(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/reimbursement_history`, ref =>
      ref.orderBy("priority", "asc")
    );
  }

  updateTask(program_id, completeduser_id, completeduser, patient_id, task_id, note) {
    return new Promise<any>((resolve, reject) => {

      const updatedAt = this.timestamp;
      const task_update = {
        completed: true,
        task_completeduser: completeduser,
        task_completeduser_id: completeduser_id,
        task_completed_note: note,
        task_completed_date: updatedAt
      }

      console.log("Update Task: ", task_id, task_update)

      var batch = this.afs.firestore.batch();

      // Update Program Task History
      const program_task_ref = this.afs.collection(`program/${program_id}/tasks`).doc(task_id).ref
      batch.update(program_task_ref, task_update);
  
      // Update Patient Task History
      const patient_task_ref = this.afs.collection(`program/${program_id}/patients/${patient_id}/task_history`).doc(task_id).ref
      batch.update(patient_task_ref, task_update);

      // Update Patient Latest Task and Chart
      const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patient_id}`).ref;
      batch.update(program_patient_docref, task_update);
  
      batch.commit().then(() => {
        console.log('batch set')
        resolve();
      })
      .catch((err) => {
        console.log('batch error')
        rejects(err);
      })
    });
  }

  getPrescriptions() {
    return this.afs.collection<any>(`prescriptions`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if (status) { query = query.where('status', '==', status) };
      return query.orderBy("createdAt", "desc")
    })
  }

  getPrescriptionsbyClinic(program_id) {
    return this.afs.collection<any>(`clinics/${program_id}/prescriptions`, ref =>
      ref
      .orderBy("createdAt", "desc")
    );
  }

  getPrescriptionsbyPatient(program_id: string, patient_id: string) {
    return this.afs.collection<any>(`clinics/${program_id}/patients/${patient_id}/prescriptions`, ref =>
      ref
      .orderBy("createdAt", "desc")
    );
  }

  getPatientsByStatus(program_id: string, status: string) {
    return this.afs.collection<any>(`program/${program_id}/patients`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if (status) { query = query.where('status', '==', status) };
      return query.orderBy("status_date", "desc")
    })
  }

  getPatientsByStatusRisk(program_id: string, status: string) {
    const now = new Date();
    const lastMidnight = now.setHours(0,0,0,0) - 8600;    
    const beginningDateObject = new Date(lastMidnight);
    return this.afs.collection<any>(`program/${program_id}/patients`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('status', '==', status).where('status_date', '<', beginningDateObject);
      return query.orderBy("status_date", "desc");
    })
  }

  getPatientsByProgramStartNoRisk(program_id: string, status: string) {
    const now = new Date();
    const lastMidnight = now.setHours(0,0,0,0);    
    const beginningDateObject = new Date(lastMidnight);
    return this.afs.collection<any>(`program/${program_id}/patients`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('status', '==', status).where('status_date', '>', beginningDateObject);
      return query.orderBy("status_date", "desc");
    })
  }


  addPatient(program_id, data: patient, count) {
    return new Promise<any>((resolve, reject) => {
     

    
    const createdAt = this.timestamp;
    const updatedAt = createdAt;
    const patientId = this.afs.createId();
    data['patient_id'] = patientId;
    data['program_id'] = program_id;
    data['status_date'] = createdAt;
    var batch = this.afs.firestore.batch();
    const doc = { createdAt, updatedAt, ...data };
    const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    batch.commit().then((setdoc) => {
      console.log(patientId)
      resolve(patientId);
    })
    .catch((err) => {
      rejects(err);
    })
  });
  }

  getPatientFromProgram(program_id, patient_id) {
    return this.afs.collection<any>(`program/${program_id}/patients/`).doc(patient_id);
  }

  updatePatient(program_id, data: patient) {
     return new Promise<any>((resolve, reject) => {
      const updatedAt = this.timestamp;
      const patientId = data.id;
      const doc = { updatedAt, ...data };
      var batch = this.afs.firestore.batch();
      const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
      batch.update(program_patient_docref, doc)
      const patient_docref = this.afs.doc(`patients/${patientId}`).ref;
      batch.update(patient_docref, doc);
      batch.commit().then((setdoc) => {
        console.log(patientId)
        resolve(patientId);
      })
      .catch((err) => {
        rejects(err);
      })
     });
  }

  updatePatientReimbursement(program_id, data: patient, reimbursement_id, reimbursement: any) {
    return new Promise<any>((resolve, reject) => {
      const updatedAt = this.timestamp;
      const patientId = data.id;
      const reimbursementId = reimbursement_id;

      var batch = this.afs.firestore.batch();

      // Update Program Reimb
      const program_reimb_docref = this.afs.doc(`program/${program_id}/reimbursements/${reimbursementId}`).ref;
      batch.update(program_reimb_docref, { id: reimbursementId, patient_id: patientId, patient_first_name: data.first_name, patient_last_name: data.last_name, updatedAt, ...reimbursement});
          
      // Create Patient Reimb
      const patient_reimb_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/reimbursement_history/${reimbursementId}`).ref;
      batch.update(patient_reimb_ref, { id: reimbursementId, updatedAt, ...reimbursement});

      batch.commit().then(() => {
        console.log('batch set')
        resolve();
      })
      .catch((err) => {
        console.log('batch error')
        rejects(err);
      })
    });
  }

  addPatientReimbursement(program_id, data: patient, reimbursement: any) {
    return new Promise<any>((resolve, reject) => {
      const createdAt = this.timestamp;
      const updatedAt = createdAt;
      const patientId = data.id;
      const reimbursementId = this.afs.createId();

      var batch = this.afs.firestore.batch();

      // Update Program Reimb
      const program_reimb_docref = this.afs.doc(`program/${program_id}/reimbursements/${reimbursementId}`).ref;
      batch.set(program_reimb_docref, { id: reimbursementId, patient_id: patientId, patient_first_name: data.first_name, patient_last_name: data.last_name, createdAt, updatedAt, ...reimbursement});
          
      // Create Patient Reimb
      const patient_reimb_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/reimbursement_history/${reimbursementId}`).ref;
      batch.set(patient_reimb_ref, { id: reimbursementId, createdAt, updatedAt, ...reimbursement});

      batch.commit().then(() => {
        console.log('batch set')
        resolve();
      })
      .catch((err) => {
        console.log('batch error')
        rejects(err);
      })
    });
  }


  addPatientChart(program_id, data: patient, note_type, note, userid, user_fullname) {
    return new Promise<any>((resolve, reject) => {
      const note_timestamp = this.timestamp;
      const chartId = this.afs.createId();
      const patientId = data.id;
      const new_chart = { id: chartId, program_patient_id: data['program_patient_id'], note: note, date: note_timestamp, type: note_type, first_name: data.first_name, last_name: data.last_name, patient_id: patientId, enteruser_id: userid, enteruser: user_fullname };
      data.updatedAt = note_timestamp;

      data['chart_note'] =  note;
      data['chart_type'] =  note_type;
      data['chart_id'] =  chartId;
      data['chart_date'] = note_timestamp;
      data['chart_enteruser_id'] = userid;
      data['chart_enteruser'] = user_fullname;
      // if(data['note_history']) {
      //   console.log('array exists, adding: ', new_note);
      //   data['note_history'].unshift(new_note);
      // } else {
      //   console.log('array doesnt exist, creating: ', new_note);
      //   data['note_history'] = [new_note];
      // }
      var batch = this.afs.firestore.batch();

      // Update Program Chart
      const program_chart_docref = this.afs.doc(`program/${program_id}/charts/${chartId}`).ref;
      batch.set(program_chart_docref, new_chart);
          
      // Create Patient Chart History
      const patient_chart_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/chart_history/${chartId}`).ref;
      batch.set(patient_chart_ref, new_chart);

      // Update Patient Latest Chart
      const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
      batch.update(program_patient_docref, data);

      batch.commit().then(() => {
        console.log('batch set')
        resolve();
      })
      .catch((err) => {
        console.log('batch error')
        rejects(err);
      })
    });
  }

  addDocument(program_id, document: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    delete document['b64'];
    document = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...document };

    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(doc_id).ref, document);
    return batch.commit();
  }

  deleteDocument(program_id, document_id) {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.doc(`program/${program_id}/docsfiles/${document_id}`).ref);
    return batch.commit();
  }

  updatePatientStatus(program_id, data: patient, status_new, substatus_new, status_note, userid, user_fullname) {
    return new Promise<any>((resolve, reject) => {
      const status_timestamp = this.timestamp;
      const statusId = this.afs.createId();
      const chartId = this.afs.createId();
      const patientId = data.id;
      const new_status = { id: statusId, status: status_new, substatus: substatus_new, status_date: status_timestamp, note: status_note, program_patient_id: data['program_patient_id'], first_name: data.first_name, last_name: data.last_name, patient_id: patientId, enteruser_id: userid, enteruser: user_fullname, };
      const new_chart = { id: chartId, program_patient_id: data['program_patient_id'], note: status_note, date: status_timestamp, type: 'Status', first_name: data.first_name, last_name: data.last_name, patient_id: patientId, enteruser_id: userid, enteruser: user_fullname };
      if (substatus_new.includes('First Call')) {
        data['Enrolment_Call_1'] = status_timestamp;
      } else if (substatus_new.includes('Second Call')) {
        data['Enrolment_Call_2'] = status_timestamp;
      } else if (substatus_new.includes('Third Call')) {
        data['Enrolment_Call_3'] = status_timestamp;
      } else {
        data[status_new.replace(/ /g, '_')] = status_timestamp;
      }
      
      data['status'] = status_new;
      data['substatus'] = substatus_new;
      data['status_id'] = statusId;
      data['status_date'] = status_timestamp;
      data['status_note'] = status_note;
      data['status_enteruser_id'] = userid;
      data['status_enteruser'] = user_fullname;
      // if(data['status_history']) {
      //   console.log('array exists, adding: ', status);
      //   data['status_history'].unshift(status);
      // } else {
      //   console.log('array doesnt exist, creating: ', status);
      //   data['status_history'] = [status];
      // }

      data['chart_note'] =  status_note;
      data['chart_type'] =  'Status';
      data['chart_id'] =  chartId;
      data['chart_date'] = status_timestamp;
      data['chart_enteruser_id'] = userid;
      data['chart_enteruser'] = user_fullname;
      // if(data['note_history']) {
      //   console.log('array exists, adding: ', new_note);
      //   data['note_history'].unshift(new_note);
      // } else {
      //   console.log('array doesnt exist, creating: ', new_note);
      //   data['note_history'] = [new_note];
      // }

      var batch = this.afs.firestore.batch();

      // Update Program Status
      const program_status_docref = this.afs.doc(`program/${program_id}/statuses/${statusId}`).ref;
      batch.set(program_status_docref, new_status);
      
      // Update Program Chart
      const program_chart_docref = this.afs.doc(`program/${program_id}/charts/${chartId}`).ref;
      batch.set(program_chart_docref, new_chart);       

      // Create Patient Status History
      const patient_status_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/status_history/${statusId}`).ref;
      batch.set(patient_status_ref, new_status);

      // Create Patient Chart History
      const patient_chart_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/chart_history/${chartId}`).ref;
      batch.set(patient_chart_ref, new_chart);

      // Update Patient Latest Status and Chart
      const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
      batch.update(program_patient_docref, data);

      batch.commit().then(() => {
        console.log('batch set')
        resolve();
      })
      .catch((err) => {
        console.log('batch error')
        rejects(err);
      })
    });
 }

 createTask(program_id, data: patient, assigned_userid, assigned_user_fullname, type, priority, reminder_date, due_date, notes, userid, user_fullname) {
  return new Promise<any>((resolve, reject) => {
    reminder_date = new Date(reminder_date);
    due_date = new Date(due_date);
    const task_timestamp = this.timestamp;
    const patientId = data.id;
    const taskId = this.afs.createId();
    const chartId = this.afs.createId();
    const task = { id: taskId, task_assigneduser_id: assigned_userid,task_assigneduser: assigned_user_fullname, task_type: type, task_priority: priority, task_reminderdate: reminder_date, task_duedate: due_date, task_date: new Date(), task_notes: notes, patient_name: data.first_name + ' ' + data.last_name, patient_id: patientId, task_program_patient_id: data['program_patient_id'], task_enteruser_id: userid, task_enteruser: user_fullname, task_completed: false}
    const new_chart = { id: chartId, program_patient_id: data['program_patient_id'], note: notes, date: task_timestamp, type: 'Task', first_name: data.first_name, last_name: data.last_name, patient_id: patientId, enteruser_id: userid, enteruser: user_fullname };
      data.updatedAt = task_timestamp;
    data['task_id'] = taskId;
    data['task_date'] =  task_timestamp;
    data['task_assigneduser'] = assigned_user_fullname;
    data['task_assigneduser_id'] = assigned_userid;
    data['task_enteruser_id'] = userid;
    data['task_enteruser'] = user_fullname;
    data['task_type'] = type;
    data['task_priority'] = priority;
    data['task_reminderdate'] = reminder_date
    data['task_duedate'] = due_date;
    data['task_notes'] = notes;
    data['task_completed'] = false;

    const chart_entry = {};
    data['chart_note'] =  notes;
    data['chart_type'] = 'Task';
    data['chart_date'] = task_timestamp;
    data['chart_id'] = chartId;
    data['chart_enteruser_id'] = userid;
    data['chart_enteruser'] = user_fullname;
    // if(data['note_history']) {
    //   console.log('array exists, adding: ', new_note);
    //   data['note_history'].unshift(new_note);
    // } else {
    //   console.log('array doesnt exist, creating: ', new_note);
    //   data['note_history'] = [new_note];
    // }

    var batch = this.afs.firestore.batch();

    // if(data['task_history']) {
    //   console.log('array exists, adding: ', task);
    //   data['task_history'].unshift(task);
    // } else {
    //   console.log('array doesnt exist, creating: ', task);
    //   data['task_history'] = [task];
    // }
    // Create Program Task
    const program_task_ref = this.afs.doc(`program/${program_id}/tasks/${taskId}`).ref;
    batch.set(program_task_ref, task);

    // Update Program Chart
    const program_chart_docref = this.afs.doc(`program/${program_id}/charts/${chartId}`).ref;
    batch.set(program_chart_docref, new_chart);       

    // Create Patient Task History
    const patient_task_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/task_history/${taskId}`).ref;
    batch.set(patient_task_ref, task);

    // Create Patient Chart History
    const patient_chart_ref = this.afs.doc(`program/${program_id}/patients/${patientId}/chart_history/${chartId}`).ref;
    batch.set(patient_chart_ref, new_chart);

    // Update Patient Latest Task and Chart
    const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    batch.update(program_patient_docref, data);

    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}

createDispensing(program_id, patient: patient, dispensing: any) {
  return new Promise<any>((resolve, reject) => {
    const dispensing_timestamp = this.timestamp;
    const patientId = patient.id;
    const dispensingId = this.afs.createId();
    const dispensing_new = { 
      id: dispensingId, date: dispensing_timestamp, ...dispensing
    }
    patient.updatedAt = dispensing_timestamp;
    patient['dispense_id'] = dispensingId;
    patient['dispense_date'] =  dispensing_timestamp;
    patient['dispense_drug'] = dispensing.drug;
    patient['dispense_quantity'] = dispensing.quantity;
    patient['dispense_din'] = dispensing.din;
    patient['dispense_pharmacy'] = dispensing.pharmacy;
    patient['dispense_firstfill_date'] = dispensing.firstfill_date;
    patient['dispense_fill_date'] = dispensing.fill_date;

    var batch = this.afs.firestore.batch();

    // Create Program dispensing
    const program_dispensing_ref = this.afs.doc(`program/${program_id}/dispensing/${dispensingId}`).ref;
    batch.set(program_dispensing_ref, dispensing_new);    

    // Create Patient dispensing History
    const patient_dispensing_ref= this.afs.doc(`program/${program_id}/patients/${patientId}/dispensing_history/${dispensingId}`).ref;
    batch.set(patient_dispensing_ref, dispensing_new);

    // Update Patient Latest
    const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    batch.update(program_patient_docref, patient);

    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}

createAE(program_id, patient: patient, ae: any) {
  return new Promise<any>((resolve, reject) => {
    const ae_timestamp = this.timestamp;
    const patientId = patient.id;
    const aeId = this.afs.createId();
    const ae_new = { 
      id: aeId, createdAt: ae_timestamp, ...ae
    }

    var batch = this.afs.firestore.batch();

    // Create Program dispensing
    const program_dispensing_ref = this.afs.doc(`program/${program_id}/adverseevents/${aeId}`).ref;
    batch.set(program_dispensing_ref, ae_new);    

    // Create Patient dispensing History
    const patient_dispensing_ref= this.afs.doc(`program/${program_id}/patients/${patientId}/ae_history/${aeId}`).ref;
    batch.set(patient_dispensing_ref, ae_new);

    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}

 updatePatientDocsFiles(program_id, data: patient, file) {
  return new Promise<any>((resolve, reject) => {
    const status_date = this.timestamp;
    const patientId = data.id;
    const docId = this.afs.createId();
    file['b64'] = null;
    data.updatedAt = status_date;
    if(data['docsfiles']) {
      data['docsfiles'].unshift({ createdAt: new Date(), ...file});
    } else {
      data['docsfiles'] = [{ createdAt: new Date(), ...file}];
    }
    console.log('starting batch update: ', program_id, patientId, data);
    var batch = this.afs.firestore.batch();
    const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    batch.update(program_patient_docref, data);
    const program_docref = this.afs.doc(`program/${program_id}/docsfiles/${docId}`).ref;
    batch.set(program_docref, { id: docId, createdAt: new Date(), program_patient_id: data['program_patient_id'], first_name: data.first_name, last_name: data.last_name, patient_id: patientId, ...file} );
    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}

 updatePatientMeds(program_id, data: patient, all, curr, prev, note, sys, dia, weight, height, userid, user_fullname) {
  return new Promise<any>((resolve, reject) => {
    const med_date = this.timestamp;
    const patientId = data.id;
    const noteId = this.afs.createId();
    const meds = { med_allergies: all, med_current: curr, med_previous: prev, med_note: note, med_date: new Date(), med_bp: sys + '/' + dia, med_bp_systolic: sys, med_bp_diastolic: dia, weight: weight, height: height, enteruser_id: userid, enteruser_fullname: user_fullname}
    const new_note = { id: noteId, note: note, note_date: new Date(), note_type: 'Medical', note_enteruser_id: userid, note_enteruser: user_fullname};
    data.updatedAt = med_date;
    data['med_date'] =  med_date;
    data['med_allergies'] = all;
    data['med_current'] = curr;
    data['med_previous'] = prev;
    data['med_bp_systolic'] = sys;
    data['med_bp_diastolic'] = dia;
    if (height) { data['height'] = height; data['height_date'] = med_date; }
    if (weight) { data['weight'] = weight; data['weight_date'] = med_date; }
    data['med_bp'] = sys + '/' + dia;
    if(data['med_history']) {
      data['med_history'].unshift(meds);
    } else {
      data['med_history'] = [meds];
    }

    data['note'] =  note;
    data['note_type'] = 'Medical';
    data['note_date'] = med_date;
    data['note_id'] = noteId;
    data['note_enteruser_id'] = userid;
    data['note_enteruser'] = user_fullname;
    if(data['note_history']) {
      data['note_history'].unshift(new_note);
    } else {
      data['note_history'] = [new_note];
    }

    console.log('starting batch update: ', program_id, patientId, data);
    var batch = this.afs.firestore.batch();
    const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    batch.update(program_patient_docref, data);
    const patient_docref = this.afs.doc(`patients/${patientId}`).ref;
    batch.update(patient_docref, data);
    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}


async updatePatientRx(program_name: string, program_id: string, patient: any, newrx: rx) {
  
  const orderId = this.afs.createId();
  newrx.id = orderId;

  return new Promise<any>((resolve, reject) => {
    const status_date = this.timestamp;
    
    const patientId = patient.id;
    
    patient.updatedAt = status_date;
    patient['rx_date'] =  status_date;
    patient['rx_doctor'] = newrx.rx_doctor;
    patient['rx_therapy'] = newrx.rx_therapy;
    patient['rx_dose'] = newrx.rx_dose;
    patient['rx_repeats'] = newrx.rx_repeats;
    patient['rx_quantity'] = newrx.rx_quantity;
    patient['rx_pharmacy'] = newrx.rx_pharmacy;
    patient['rx_notes'] = newrx.rx_notes;
    patient['rx_status'] = newrx.rx_status;
    patient['rx_url'] = newrx.rx_url;

    var batch = this.afs.firestore.batch();

    // const program_patient_docref = this.afs.doc(`program/${program_id}/patients/${patientId}`).ref;
    // batch.update(program_patient_docref, patient);

    const program_patient_orderref = this.afs.doc(`program/${program_id}/patients/${patientId}/order_history/${orderId}`).ref;
    batch.set(program_patient_orderref, newrx);

    const program_orderref = this.afs.doc(`program/${program_id}/orders/${orderId}`).ref;
    batch.set(program_orderref, newrx);

    batch.commit().then(() => {
      console.log('batch set')
      resolve();
    })
    .catch((err) => {
      console.log('batch error')
      rejects(err);
    })
  });
}

  getUsers() {
    return this.afs.collection("users", ref => 
      ref.orderBy("last_name", "asc")
    );
  }

  async updateUser(user_id, data) {
    return await this.afs.collection('users').doc(user_id).set(data, {merge: true});
  }

  deletePatient(program_id, patient_id) {
    var batch = this.afs.firestore.batch();
    const patientRef = this.afs.doc(`program/${program_id}/patients/${patient_id}`).ref;
    batch.delete(patientRef);
    return batch.commit();
  }

  async addMedication(med)  {
    return await this.afs
    .collection("medications")
    .doc(med.din)
    .set(med);
  }

  async addSupply(supply)  {
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedAt = createdAt;
    const doc = { createdAt, updatedAt, ...supply };
    return await this.afs
    .collection(`supplies`)
    .doc(supply.din)
    .set(doc);
  }

  async updateSupply(supply)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const doc = { updatedAt, ...supply };
    return await this.afs
    .collection(`supplies`)
    .doc(supply.din)
    .update(doc);
  }

  async addSupplyByClinic(program_id, supply)  {
    var batch = this.afs.firestore.batch();
    // batch.delete(patientRef);

    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedAt = createdAt;
    const doc = { createdAt, updatedAt, ...supply };
    const clinicSuppliesRef = this.afs.doc(`clinics/${program_id}/supplies/${supply.din}`).ref;
    batch.set(clinicSuppliesRef , doc);

    return batch.commit();
  }

  async updateSupplyByClinic(program_id, supply)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const doc = { updatedAt, ...supply };
    return await this.afs
    .collection(`clinics/${program_id}/supplies`)
    .doc(supply.din)
    .update(doc);
  }

  async deleteSupplyByClinic(program_id, supply_din) {
    return await this.afs
    .collection(`clinics/${program_id}/supplies`)
    .doc(supply_din)
    .delete();
  }

  getSupplyByClinic(program_id)  {
    return this.afs.collection("supplies", ref => 
      ref
        .where("clinics", "array-contains", program_id)
        .orderBy("sort", "asc")
    );
  }

  getDefaultSuppliesByClinic(program_id)  {
    return this.afs.collection("supplies", ref => 
      ref
        .where("clinics_default", "array-contains", program_id)
        .orderBy("sort", "asc")
    );
  }

  follow(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();

    const data = {
      followerId,
      followedId,
      createdAt
    };

    return this.afs
      .collection("relationships")
      .doc(docId)
      .set(data);
  }

  unfollow(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);

    return this.afs
      .collection("relationships")
      .doc(docId)
      .delete();
  }

  isFollowing(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);

    return this.afs
      .collection("relationships")
      .doc(docId)
      .valueChanges();
  }

  getDoc(path,document)  {
    return this.afs.collection<any>(path).doc(document);
  }

  setDoc(path,document_id, document) {
    return this.afs
    .collection(path)
    .doc(document_id)
    .set(document);    
  }

  updateDoc(path,document_id, document) {
    return this.afs
    .collection(path)
    .doc(document_id)
    .update(document);
  }

  getCollection(path)  {
    return this.afs.collection<any>(path);
  }

  setDocWithID(path, document) {
    return new Promise<any>((resolve, reject) => {
      const createdAt = this.timestamp;
      const updatedAt = createdAt;
      const id = this.afs.createId();
      const doc = { id, createdAt, updatedAt, ...document };
      const afscoll = this.afs.collection(path)
      afscoll.doc(id).set(doc).then((setdoc) => {
        console.log(id)
        resolve(id);
      })
      .catch((err) => {
        rejects(err);
      })
    });
  }


  // Helper to format the docId for relationships
  private concatIds(a: string, b: string) {
    return `${a}_${b}`;
  }

  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  createStudy(program_id, patient_id, studydata, old_study_id): Promise<void> {

    if(!studydata.createdAt)  {
      studydata.createdAt = this.timestamp;
      studydata.updatedAt = this.timestamp;
    }
   
    const id = this.afs.createId();

    var batch = this.afs.firestore.batch();
    const preRef = this.afs.doc(`studyresults/${id}`).ref;
    batch.set(preRef , studydata);

    const clinicRef = this.afs.doc(`clinics/${program_id}/studyresults/${id}`).ref;
    batch.set(clinicRef , studydata);

    const patientRef = this.afs.doc(`clinics/${program_id}/patients/${patient_id}/studyresults/${id}`).ref;
    batch.set(patientRef , studydata);

    if(old_study_id)  {
      const old_preRef = this.afs.doc(`studyresults/${old_study_id}`).ref;
      batch.update(old_preRef, {"Renewed": true, "past_study_id": old_study_id });
  
      const old_clinicRef = this.afs.doc(`clinics/${program_id}/studyresults/${old_study_id}`).ref;
      batch.update(old_clinicRef, {"Renewed": true, "past_study_id": old_study_id });
  
      const old_patientRef = this.afs.doc(`clinics/${program_id}/patients/${patient_id}/studyresults/${old_study_id}`).ref;
      batch.update(old_patientRef, {"Renewed": true, "past_study_id": old_study_id });
    }

    return batch.commit();
  }

  completeStudy(study_id, program_id, patient_id, study): Promise<void> {
    study.updatedAt = this.timestamp;
    var batch = this.afs.firestore.batch();

      const old_preRef = this.afs.doc(`studyresults/${study_id}`).ref;
      batch.update(old_preRef, study);
  
      const old_clinicRef = this.afs.doc(`clinics/${program_id}/studyresults/${study_id}`).ref;
      batch.update(old_clinicRef,study);
  
      const old_patientRef = this.afs.doc(`clinics/${program_id}/patients/${patient_id}/studyresults/${study_id}`).ref;
      batch.update(old_patientRef, study);

    return batch.commit();
  }

  getStudiesByClinicFollowUp(program_id)  {
    let dueDate: moment.Moment = moment();
    dueDate = dueDate.add(-10, "M");
    return this.afs.collection<any>(`clinics/${program_id}/studyresults`, ref => 
      ref
        .where('Renewed', '==', false)
        .where('createdAt', '<', dueDate.toDate())
        .orderBy('createdAt')
      );
  }

  getPrescriptionsByClinicFollowUp(program_id)  {
    let dueDate: moment.Moment = moment();
    dueDate = dueDate.add(-10, "M");
    return this.afs.collection<any>(`clinics/${program_id}/prescriptions`, ref => 
      ref
        .where('Renewed', '==', false)
        .where('createdAt', '<', dueDate.toDate())
        .orderBy('createdAt')
      );
  }

  updateOrderStatus(program_id, patient_id, order_id, status, date)  {
     
    var batch = this.afs.firestore.batch();
    const orderRef = this.afs.doc(`program/${program_id}/orders/${order_id}`).ref;
    batch.update(orderRef, { rx_status: status, rx_fulfillment_date: new Date(date) });

    const patientOrderRef = this.afs.doc(`program/${program_id}/patients/${patient_id}/orders/${order_id}`).ref;
    batch.update(patientOrderRef, { rx_status: status, rx_fulfillment_date: new Date(date) });

    const patientRef = this.afs.doc(`clinics/${program_id}/patients/${patient_id}/prescriptions/${order_id}`).ref;
    return batch.commit()

  }

  deleteUser(uid) {

    var headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    let body =  `secret=${ENV.API_SECRET}&uid=` + uid;
    
    return new Promise((resolve, reject) => {
       this.http.post(`${ENV.FIREBASE_API_URL}/deleteUser`, body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              // console.log('information from the api call',data);
              // this.local.set('agendaData', data);

              //this.data = data;
              resolve(data);
          },
          (err) => {
              if (err.status === 401) {
                  // return to login screen - Unauthorized
                  reject(new Error('You currently don’t have access to Scheduler. Please contact support'));

              }
              else if (err.status === 403) {
                  //Display Exception message, and go to support view - Forbidden
                  reject(new Error("Your access is forbidden."))
              }
              else if (err.status === 400) {
                  console.error(err);
                  if (err._body) {
                      console.info(err._body);
                      reject(new Error(err._body));
                  }
                  else
                      reject(new Error(err.statusText));
              }
              else {
                  reject(new Error("Could not save data to the server."));
              }

          }
          )
  });
  }

  createUser(user) {
  
    var headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    let body = `secret=${ENV.API_SECRET}&email=` + user.email + `&password=` + user.password + `&phone_number=` + encodeURIComponent(user.phone_number) + `&first_name=` + encodeURIComponent(user.first_name) + `&last_name=` + encodeURIComponent(user.last_name) + `&program_id=` + user.program_id + `&program_name=` + encodeURIComponent(user.program_name) + `&navigator_admin=` + user.navigator_admin + `&program_admin=` + user.program_admin + `&navigator_ncm=` + user.navigator_ncm + `&navigator_rcm=` + user.navigator_rcm;
    
    return new Promise((resolve, reject) => {
       this.http.post(`${ENV.FIREBASE_API_URL}/createUser`, body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              // console.log('information from the api call',data);
              // this.local.set('agendaData', data);

              //this.data = data;
              resolve(data);
          },
          (err) => {
              if (err.status === 401) {
                  // return to login screen - Unauthorized
                  reject(new Error('You currently don’t have access to Scheduler. Please contact support'));

              }
              else if (err.status === 403) {
                  //Display Exception message, and go to support view - Forbidden
                  reject(new Error("Your access is forbidden."))
              }
              else if (err.status === 400) {
                  console.error(err);
                  if (err._body) {
                      console.info(err._body);
                      reject(new Error(err._body));
                  }
                  else
                      reject(new Error(err.statusText));
              }
              else {
                  reject(new Error("Could not save data to the server."));
              }

          }
          )
  });
  }



  getUniqueAENumber(program_id)  {
    return new Promise((resolve, reject) => {
      const increment = firebase.firestore.FieldValue.increment(1);
      const program = this.afs.doc(`program/${program_id}`);
      program.update({ aeautoindex: increment }).then(t => {
        program.ref.get().then(function(doc) {
          if (doc.exists) {
            resolve(doc.data().aeautoindex);
          } else {
            reject(null);
          }
        })
        .catch(err => {
          reject(err);
        })
      })
      .catch(err => {
        reject(err);
      })
    });
  }

  getUniqueShipmentNumber(program_id)  {
    return new Promise((resolve, reject) => {
      const increment = firebase.firestore.FieldValue.increment(1);
      const program = this.afs.doc(`program/${program_id}`);
      program.update({ shipmentautoindex: increment }).then(t => {
        program.ref.get().then(function(doc) {
          if (doc.exists) {
            resolve(doc.data().shipmentautoindex);
          } else {
            reject(null);
          }
        })
        .catch(err => {
          reject(err);
        })
      })
      .catch(err => {
        reject(err);
      })
    });
  }

  getUniqueOrderNumber(program_id)  {
    return new Promise((resolve, reject) => {
      const increment = firebase.firestore.FieldValue.increment(1);
      const program = this.afs.doc(`program/${program_id}`);
      program.update({ orderautoindex: increment }).then(t => {
        program.ref.get().then(function(doc) {
          if (doc.exists) {
            resolve(doc.data().orderautoindex);
          } else {
            reject(null);
          }
        })
        .catch(err => {
          reject(err);
        })
      })
      .catch(err => {
        reject(err);
      })
    });
  }

  sendFax(fax_number, url)  {
    var headers = new Headers()
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({ headers: headers });
    let body = {
      secret: 'dd4c6e15-647b-41e9-b8f0-6dc8d6bc5ba1',
      from_number: '+18449800416',
      to_number: fax_number,
      media_url: url
    }
    console.log('Body: ', body);
    return new Promise((resolve, reject) => {
      this.http.post(`${ENV.FIREBASE_API_URL}/sendFax`, body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              resolve(data);
          },
          (err) => {
            
              if (err.status === 401) {
                  // return to login screen - Unauthorized
                  reject(new Error('No access'));

              }
              else if (err.status === 200) {
                //Display Exception message, and go to support view - Forbidden
                resolve(err);
            }
              else if (err.status === 403) {
                  //Display Exception message, and go to support view - Forbidden
                  reject(new Error("No access"))
              }
              else if (err.status === 400) {
                  console.error(err);
                  if (err._body) {
                      console.info(err._body);
                      reject(new Error(err._body));
                  }
                  else
                      reject(new Error(err.statusText));
              }
              else {
                  reject(new Error("Could not save data to the server."));
              }

          }
          )
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts